<script lang="ts">
  let tabMouseDown = false;
  let tabStartX: number;
  let tabScrollLeft: number;

  const startTabDragging = e => {
    tabMouseDown = true;
    tabStartX = e.pageX - e.target.offsetLeft;
    tabScrollLeft = e.target.scrollLeft;
  };

  const stopTabDragging = () => {
    tabMouseDown = false;
  };
</script>

<div
  role="button"
  tabindex="0"
  class="flex flex-row px-6 gap-6 justify-start items-center overflow-x-hidden float-left border-b border-grey-transparency-dark-4 active:cursor-grab {$$props.class}"
  on:mousedown={startTabDragging}
  on:mouseup={stopTabDragging}
  on:mouseleave={stopTabDragging}
  on:mousemove|preventDefault={e => {
    if (!tabMouseDown) return;
    const x = e.pageX - e.currentTarget.offsetLeft;
    const scroll = x - tabStartX;
    e.currentTarget.scrollLeft = tabScrollLeft - scroll;
  }}
  on:wheel|preventDefault={e => {
    e.currentTarget.scrollLeft += e.deltaY;
  }}
>
  <slot />
</div>
